import {Stack} from 'shells/layout/stack/stack';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import type {HeaderFieldFragment} from 'nutshell-graphql-types';

import {HeaderFieldToggle} from './header-field-toggle';

interface Props {
    headerFields: HeaderFieldFragment[];
    onToggle: (headerFieldName: string, isEnabled: boolean) => void;
    isLoading: boolean;
}

export function HeaderFieldToggleSection(props: Props) {
    return (
        <Stack spacing={16} isFullWidth={true}>
            <Body isBold={true}>Header</Body>
            {props.isLoading ? (
                <LoadingPage fullHeight={false} />
            ) : (
                <div className='pr-8'>
                    <Stack spacing={24} isFullWidth={true}>
                        {props.headerFields.map((headerField) => (
                            <HeaderFieldToggle
                                key={headerField.type}
                                headerField={headerField}
                                onToggle={(isEnabled: boolean) =>
                                    props.onToggle(headerField.type, isEnabled)
                                }
                            />
                        ))}
                    </Stack>
                </div>
            )}
        </Stack>
    );
}
